import React from 'react';
import AntdDatePicker from  'antd/lib/date-picker';
import { withError} from '@fishx/tracker';

export const DatePicker = (props) => <AntdDatePicker {...props}/>
DatePicker.displayName = 'DatePicker';
export default withError(DatePicker);



// WEBPACK FOOTER //
// ./src/components/date-picker/index.tsx